// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag-search-results__wrapper .tag-search-results__search-input[data-v-f35f72de]{display:block;width:800px;max-width:100%;margin:40px auto 0}@media (max-width:767px){.tag-search-results__wrapper .tag-search-results__search-input[data-v-f35f72de]{width:100%;margin-top:20px}}.tag-search-results__wrapper .tag-search-results__results[data-v-f35f72de]{margin-top:30px}", ""]);
// Exports
module.exports = exports;
